<template>
  <div class="dialogCon" v-if="data.useDialog && data.message">
    <div class="layerPopup">
      <div v-html="data.message"></div>

      <div class="btn">
        <a
          @click="
            data.getCloseButtonEvent();
            closePopup();
          "
        >
          {{ data.getCloseBtnName }}
        </a>

        <a
          v-if="data.getBtnCount === 2 && data.getBtnName"
          @click="
            data.getButtonEvent();
            closePopup();
          "
        >
          {{ data.getBtnName }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogPopup',
  data() {
    return {
      data: {
        useDialog: false,
        message: '',
        getBtnCount: 1,
        getBtnName: '확인',
        getButtonEvent: () => {}
      }
    };
  },
  mounted() {
    const defaultData = () => {
      return {
        useDialog: false,
        message: '',
        getBtnCount: 1,
        getBtnName: '확인',
        getCloseBtnName: '',
        getCloseButtonEvent: () => {
          this.data.useDialog = false;
        },
        getButtonEvent: () => {
          this.data.useDialog = false;
        }
      };
    };
    this.data = defaultData();
    this.$mitt.on('DialogPopup', (val) => {
      try {
        this.data.useDialog = val.useDialog || defaultData().useDialog;
        this.data.message = val.message || defaultData().message;
        this.data.getBtnCount = val.getBtnCount || defaultData().getBtnCount;
        this.data.getBtnName = val.getBtnName || defaultData().getBtnName;
        this.data.getCloseButtonEvent = val.getCloseButtonEvent || defaultData().getCloseButtonEvent;
        this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent;
        if (val.getCloseBtnName) {
          this.data.getCloseBtnName = val.getCloseBtnName;
        } else {
          this.data.getCloseBtnName = this.data.getBtnCount === 1 ? '확인' : '취소';
        }
      } catch (e) {
        console.log(e);
      }
    });
  },
  methods: {
    closePopup() {
      this.data.useDialog = false;
    }
  }
};
</script>
